import { SourceMapConsumer } from 'source-map-js';
import { getGitHubUrl } from './github';

/**
 * Fetches a source map and finds the original position of a compiled line of code.
 */
const getOriginalPosition = async (filename: string, line: number, column: number) => {
  try {
    const response = await fetch(filename);
    const content = await response.text();
    const sourceMapMatch = content.match(/\/\/# sourceMappingURL=(.+)$/m);

    if (!sourceMapMatch) return null;

    const sourceMapUrl = new URL(sourceMapMatch[1], filename).href;
    const sourceMapResponse = await fetch(sourceMapUrl);
    const sourceMapData = await sourceMapResponse.json();

    const consumer = await new SourceMapConsumer(sourceMapData);
    const originalPosition = consumer.originalPositionFor({ line, column });

    if (originalPosition.source && originalPosition.line) {
      return {
        ...originalPosition,
        column: originalPosition.column + 1,
        githubUrl: getGitHubUrl(originalPosition.source),
      };
    }

    return null;
  } catch (error) {
    console.warn('Failed to parse source map:', error);
    return null;
  }
};

export { getOriginalPosition };